import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UpgradeSlice {
  actionStatusList: any;
  modelList: string[];
  upgradeLoading: boolean;
}

const initialState: UpgradeSlice = {
  actionStatusList: [],
  modelList: [],
  upgradeLoading: false,
};

/* actionStatusList: 用於存儲操作狀態的陣列。初始值為空陣列。
   modelList: 用於存儲模型列表的字串陣列。初始值為空陣列。
   upgradeLoading: 用於表示升級操作是否正在進行的布林值。初始值為 false
*/
const upgradeSlice = createSlice({
  name: "upgrade",
  initialState,
  reducers: {
    setActionStatusList: (state, action: PayloadAction<any>) => {
      state.actionStatusList = action.payload;
    },
    setModelList: (state, action: PayloadAction<string[]>) => {
      state.modelList = action.payload;
    },
    setuUgradeLoading: (state, action: PayloadAction<boolean>) => {
      state.upgradeLoading = action.payload;
    },
  },
});

export const { setActionStatusList, setModelList, setuUgradeLoading } = upgradeSlice.actions;

export default upgradeSlice;
